var _ellipse, _ellipse2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellbeingHubActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5391,
    cy: 24.9682,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_9428_127784)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5389,
    cy: 24.9678,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_9428_127784)",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1973,
    cy: 12.5,
    r: 12.5,
    fill: "#BBF484"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4971,
    cy: 13,
    r: 2.75,
    fill: "#3BE1CE",
    stroke: "#6048A1",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4971,
    cy: 7,
    r: 1.75,
    fill: "#FFE665",
    stroke: "#6048A1",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99707,
    cy: 7.5,
    r: 1.25,
    fill: "#BBF484",
    stroke: "#6048A1",
    strokeWidth: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9976,
    cy: 16.5,
    r: 1.25,
    fill: "#FFAF83",
    stroke: "#6048A1",
    strokeWidth: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7964,
    cy: 19,
    r: 0.75,
    fill: "#D4C6F9",
    stroke: "#6048A1",
    strokeWidth: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.39746,
    cy: 14.1992,
    r: 0.75,
    fill: "#3FB9FC",
    stroke: "#6048A1",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09717 8.59766L11.5259 10.7571",
    stroke: "#6048A1",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 14.6973L17.8304 15.6724",
    stroke: "#6048A1",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3521 16.0078L13.0422 17.9837",
    stroke: "#6048A1",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3604 8.43164L15.0622 10.7295",
    stroke: "#6048A1",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39746 13.9414L10.5367 13.1005",
    stroke: "#6048A1",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9428_127784",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5391 24.9682) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9428_127784",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5389 24.9678) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeingHubActive);
export default __webpack_public_path__ + "static/media/wellbeing-hub-active.d59ad8d79e9733c3def8f7f2b862417d.svg";
export { ForwardRef as ReactComponent };